import React, { useCallback } from 'react'
import classNames from 'classnames'
import ResponsiveScrollableWrapper from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import s from './Main.less'
import { isGE } from '../Device'
import { HEADER_SUBHEADER_HEIGHT, PREHEADER_HEIGHT } from '../header/header-constants'
import { selectHeaderHeight, selectMainPEPositionAtStart } from '../../store/ui/ui.selectors'
import { useSelector } from 'react-redux'
import { MINI_MAP_HEIGHT, PE_MAIN_START_POS, PE_MAIN_VALUES } from './main.constants'

import Anchor from '../genericComponents/Anchor'

const Main = ({ children, className, withoutSubHeader }) => {
  const headerHeight = useSelector(selectHeaderHeight)
  const { high, highNoMap } = PE_MAIN_START_POS
  const positionAtStart = useSelector(selectMainPEPositionAtStart)
  const windowHeight = global?.window?.innerHeight ?? 0

  const getStyle = useCallback(() => {
    if (__SERVER__) return {}

    const headerWithSubHeaderHeight = headerHeight + (withoutSubHeader ? 0 : HEADER_SUBHEADER_HEIGHT)
    if (isGE()) {
      const top = PREHEADER_HEIGHT + headerWithSubHeaderHeight
      const height = `calc(100vh - ${top}px)`
      return { top, height }
    }

    const minTop = headerWithSubHeaderHeight + MINI_MAP_HEIGHT
    const top =
      positionAtStart === highNoMap
        ? headerWithSubHeaderHeight - 4
        : positionAtStart === high
        ? minTop
        : Math.max(minTop, windowHeight - PE_MAIN_VALUES[positionAtStart])

    return {
      top,
      height: null
    }
  }, [headerHeight, positionAtStart, withoutSubHeader, windowHeight])

  return (
    <main className={classNames(s.Main, s.Main_displayed, className)} style={getStyle()}>
      <Anchor />
      <ResponsiveScrollableWrapper>{children}</ResponsiveScrollableWrapper>
    </main>
  )
}

export default Main
